export const dataEntryStatuses = {
  unbegun: "unbegun", // no records exist
  incomplete: "incomplete", // at least one record exists
  complete: "complete", // all records have complete status
  unavailable: "unavailable", // front-end only status for current and future months
};
